<template>
  <v-card flat class="dialog-card">
    <v-toolbar flat light color="white">
      <v-toolbar-title>{{ $t('debtInformation') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container fluid>
      <debt-info :debt="debt"></debt-info>
      <v-row v-if="debt.debtSummary.state.state === 5">
        <v-col cols="12">
          <p v-html="$t('distraintPaymentWarning')" />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import LowerSummary from '../Summary/Lower.vue'

  export default {
    props: ['debt'],
    components: {
      'debt-info': LowerSummary
    }
  }
</script>
